export default "__VITE_ASSET__CpyIt71___"